var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404Bg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    viewBox: "0 0 883.864 655.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M655.417,334.928c-5.149.589-15,7.267-16.328,17.784s12.863,16.543,19.49,16.344c9.708-.3,19.418-11.254,12.209-22.948S655.417,334.928,655.417,334.928Z",
    transform: "translate(-639.003 -334.925)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M661.044,426.909c3.9,3.417,15.466,6.224,24.142.133s3.6-20.645-1-25.415c-6.744-6.989-21.385-6.811-25.2,6.388S661.044,426.909,661.044,426.909Z",
    transform: "translate(-657.699 -397.047)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-288.538 -104.816)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.951, -0.309, 0.309, 0.951, 636.26, -20.646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M723.128,350.544s-11.659-4.57-9.254-11.221,10.722-18.015,12.962-17.353.885,5.074,4.045,7.06,9.295-.11,11.523,2.207S737.81,352.861,723.128,350.544Z",
    transform: "translate(-407.466 38.845)",
    fill: "#dceaf8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.885,357.4c-.667-.863-6.048,4.446-6.79,4.321-1.655-.276-3.806-1.942-5.407.408s.709,2.692,1.237,3.79-2.726,2.736-1.732,4.151,4.32-1.5,4.817-1.163-1.231,4.829,1.472,4.972,3.364-3.073,5.461-3.7c.7-.209,5.094-1.289,5.456-2.737S720.55,358.266,719.885,357.4Z",
    transform: "translate(-410.184 53.535)",
    fill: "#ef7e17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736,376.875c.191-.72,1.641-2.216,2.151-3.724s-3.965-3.25-5.458-3.925c-.546-.246-1.683-1-2.415-.277s-1.367,3.282-1.946,3.182c-1.268-.221-4.855.11-4.91,3.035s4.082,1.6,4.524,2.426-4.579,3.22-2.1,5.914,5.407-4.037,6.344-3.486.11,5.1,3.09,4.124S735.509,378.751,736,376.875Z",
    transform: "translate(-403.361 58.243)",
    fill: "#ef7e17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.492,376.155c-.14-.556-.662-2.832-1.282-3.112-.277-.125-2.634.812-4.675,1.237-2.541.528-4.849.621-5.008,1.117a2.524,2.524,0,0,0,.208,1.752c.276,1.71-.736,5.989,1.049,6.62s1.943-1.6,2.985-1.435,1.152,2.814,2.641,2.648.607-3.53,2.041-3.916,3.243,1.458,4.269-.484S765.933,377.92,765.492,376.155Z",
    transform: "translate(-390.483 60.066)",
    fill: "#ef7e17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.739,383.308a1.4,1.4,0,0,0,.592,1.2c.389.29,1.847-.365,2.819-1.316a11.729,11.729,0,0,0,3.461-8.031,19.14,19.14,0,0,0-2.158-8.93c-1.189-2.272-2.031-2.858-3.029-4.429a5.769,5.769,0,0,0-2.139-2.286c-9.929-3.458-15.279-7.122-14.011-8.958s3.751-7.9,2.538-9.889-1.049-1.921.166-4.381,4.025-8.123.661-9.484-8.308,4.182-11.01,3.439-2.95-3.807-7.884-5.628-6.921-.661-8.134-2.151-.442-5.571-2.759-5.571c-1.557,0-4.9,8.427-6.48,9.426s.66.853,4.314.484,13.105,4.134,14.136,8.514-2.427,14.089-9.211,14.464-12.3.651-9.292,4.347,7.366,8.771,5.459,10.923c-.74.837-4.992,4.02-4.927,5.381.034.706,1.858,3.18,3.187,6.037,1.238,2.66,1.958,5.732,2.712,5.85,1.564.246,4.6-1.781,5.122-1.492,1.1.607,5.129,2.483,5.626,3.476.119.236-.443.97-.3,1.781s.125.82,1.882,1.574,6.109,3.683,6.679,3.516,1.318-1.594,1.616-1.52c.205.051.854.674,1.365-.367a36.78,36.78,0,0,0,1.964-5.081c.479-1.587.8-3.4,1.96-4.667a5.793,5.793,0,0,1,5.608-1.54,40.67,40.67,0,0,1,5.848,1.193C763.844,379.785,765.93,381.165,765.739,383.308Z",
    transform: "translate(-405.833 36.748)",
    fill: "#4b7eba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.505,363.573c2.306-3.53,10.085-10.591,4.954-19.361s-12.411-10.073-19.692-8.071-13.81,4.654-16.6,1.561.331-12.246,5.461-12.8,7.446-2.483,4.634-5.405-11.97-.5-15.336,8.825,2.859,15.432,8.491,17.122,15.616-5.371,21.353-3.717,7.612,12.246,2.538,15.886a20,20,0,0,1-11.033,3.714c-4.349.191-10.734-1.23-10.829-.79-.208.977,2.325,3.437,3.053,5.446,1.3,3.6,2.127,7.369,1.36,11.184a14.838,14.838,0,0,1-5.228,9.1,11.736,11.736,0,0,1-6.777,2.045c-.15.528.3,1.85,1.155,1.905.685.044,1.592,3.878,2.592,4.117.5.119,2.991-.7,5.546-1.165s5.17-.566,5.506-.948c.672-.763-.627-3.872-.238-4.279.992-1.035,3.309.178,5.737-2.192s4.7-1.06,5.276-1.33a58.926,58.926,0,0,0,5.9-6.78c1.122-1.587,2.941-4.072,3.016-5.823S783.2,367.1,785.505,363.573Z",
    transform: "translate(-393.166 37.345)",
    fill: "#4b7eba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.591,369.644c-.44-2.924-3.861-.023-4.853-1.639-.729-1.186-3.71-8.279-4.4-8.378s-2.231,2.194-3.3,3.7c-1.087,1.531-2.181,3.06-3.344,4.535a3.813,3.813,0,0,0-1.105,2.055c-.028.8,3.969,2.9,4.09,3.537.219,1.159.11,4.579,1.71,5.626s3.972-1.9,4.8-1.472,3.311,1.638,4.634-1.175-3.088-3.591-3.2-4.359S789.032,372.568,788.591,369.644Z",
    transform: "translate(-383.354 54.497)",
    fill: "#ef7e17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.789,349.254s3.693-10.279-5.214-22.929-33.846-28.243-18.066-52.074,46.882-5.737,55.381,12.8,15.561,37.041,41.6,31.318,13.681-51.176,39.717-48.088",
    transform: "translate(-408.36 14.3)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.205,338.573a3.723,3.723,0,0,0,2.7-.579,5.469,5.469,0,0,0,1.6-2.108,10.331,10.331,0,0,0,0,3.789,4.237,4.237,0,0,0,1.765,1.9",
    transform: "translate(-405.53 44.638)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.751,334.576c-.535.331-.139,1.523.8,1.892s2.979.262,2.869-.208S721.55,334.08,720.751,334.576Z",
    transform: "translate(-404.573 44.056)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.911,333.248c1.07.427.166,3.2-1.352,2.87S727.393,332.641,728.911,333.248Z",
    transform: "translate(-401.921 43.509)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.845,330.648c.989.344-.248,2.943-1.434,2.56S719.577,330.206,720.845,330.648Z",
    transform: "translate(-405.22 42.44)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.957,324.26a9.086,9.086,0,0,1,.556,1.49c.515,1.765.882,3.311,2.72,4.047s6.252,3.015,7.65,3.749a1.692,1.692,0,0,0,1.708-.3",
    transform: "translate(-403.557 39.808)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.255,348.56a30.288,30.288,0,0,1-6.178-5.47c-2.575-3.151.072-7.711,1.912-9.257,1.728-1.452,4.189-7.79,5.722-9.729",
    transform: "translate(-406.859 39.742)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.453,375.613s9.114,2.433,13.085-4.461,5.453-13.768-4.917-24.142",
    transform: "translate(-392.966 49.257)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.676,373.8s4.276.9,7.107-.457,7.429-6.635,6.068-12.945c-1.078-5-8.74-14.092-8.74-14.092",
    transform: "translate(-392.873 48.964)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.734,365.206c.515,1.03-.754,6.458-1.122,6.972s-5.7-.408-8.365-1.932-.093-7.557,2.408-7.042S751.219,364.177,751.734,365.206Z",
    transform: "translate(-396.014 55.972)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.19,368.174c.309-2.17.359-4.246-.181-4.978-1.251-1.693-11.843-3.088-13.387-2.207s-3.824,8.458-4.045,9.489c-.186.865,4.413,3.088,8.164,3.9s6.693.587,7.649,0c.406-.249.982-1.993,1.418-4.047",
    transform: "translate(-397.071 54.951)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.074,346.783a6.572,6.572,0,0,1,5.2,4.161",
    transform: "translate(-383.984 49.163)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.259,369.643c.82.589,4.743-3.346,6.215-5.479s3.456-4.671,2.426-5.847-3.639,3.162-5.442,5.332S768.824,368.614,770.259,369.643Z",
    transform: "translate(-384.071 53.872)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.438,373.838c.137,1,2.831,1.03,7.061,0s4.669-1.582,4.412-2.243-4.154-.038-6.03.44S753.291,372.772,753.438,373.838Z",
    transform: "translate(-390.896 59.351)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.194,366.8c-.395.887,2.023,2.9,5.369,4.229s5.48,2.059,5.885,1.213-3.127-2.61-5.628-3.788S728.636,365.807,728.194,366.8Z",
    transform: "translate(-401.398 57.342)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.162,355.706c-.961.812.607,4.3,1.875,6.674s2.906,6.031,4.505,5.315-1.141-4.487-2.243-7.025S718.6,354.491,717.162,355.706Z",
    transform: "translate(-406.087 52.77)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.863,337.083s8.218,1.744,11.748,2.638,18.038,4.644,19.031,5.2a22.228,22.228,0,0,1,3.245,3.156",
    transform: "translate(-395.703 45.134)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.783,343.813s2.153-5.132,3.2-4.856,29.292,7.391,30.727,8.164-1.1,5.645-1.1,5.645",
    transform: "translate(-395.736 45.908)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.472,339.091c.955.316,1.386-1.186.444-1.526S733.5,338.77,734.472,339.091Z",
    transform: "translate(-398.997 45.314)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.42,335.26a.725.725,0,0,0-.243,1.425C736.032,336.888,736.169,335.352,735.42,335.26Z",
    transform: "translate(-398.709 44.374)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.828,332.569c-.518-.076-.985,1.032-.286,1.253S736.62,332.689,735.828,332.569Z",
    transform: "translate(-398.477 43.258)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.921,331.766c.776.185,1.178.979,1.008,4.18-.088,1.66-.655,7.688-3.2,7.016",
    transform: "translate(-398.666 42.926)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736,331.731c-.711.449-3.807,9.432-3.2,10.426s10.426,1.82,11.309,1.379,2.481-7.667,2.1-8.44S737.052,331.069,736,331.731Z",
    transform: "translate(-399.499 42.874)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.359,355.719s5.649,1.573,13.923-3.172a32.134,32.134,0,0,0,11.826-11.526",
    transform: "translate(-403.805 46.771)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.918,340.243c2.024-4.633,4.808-11.165,3.4-12.37-1.875-1.6-9.71,4.137-10.867,3.806s-3.035-3.42-5.626-4.652-7.558-2.078-10.812-3.4-2.317-6.675-4.413-6.73-5.264,11.046-5.264,11.046",
    transform: "translate(-405.894 36.748)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.048,374.926c-2.03-3.413-4.175-7.043-4.246-8.913-.11-2.924,9.763-8.826,8.274-17.927s-12.246-12.743-17.377-11.64-18.2,6.178-21.347,0,2.757-12.356,8.661-12.577c4.93-.184,3.7-3.916.606-4.909s-10.315-.662-13.238,7.612.882,15.886,7.5,17.653,13.405-2.151,20.686-1.986,9.1,10.15,2.7,16.549-26.533-1.38-34.643-3.863c-4.28-1.309-6.562-3.526-7.568-5.839",
    transform: "translate(-396.452 37.442)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.363,368.493c2.866,2.066,5.742,4.2,6.181,4.654.691.72-.963,1.992-.412,3.432a1.95,1.95,0,0,0,3.34.5c.933-1.131.7-2.659,1.448-2.575.661.074.149,1.973,1.734,2.563s3.086-.389,2.955-1.885-2.362-2.158-2.061-2.655c.386-.634,3.061.773,3.172-1.628s-2.951-1.36-3.723-1.489c-1.088-.181-2.151-2.427-4.027-6.4-.408-.863-1.13-2.146-1.764-3.238",
    transform: "translate(-383.449 54.561)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.954,374.8c-.479-2.767-.831-5.371-.643-5.819.4-.955,4.045-1.323,5.7-2.647s3.127-3.752,3.826-3.421c.276.132,2.126,1.415,4.316,2.975",
    transform: "translate(-388.062 55.853)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.753,374.163a31.3,31.3,0,0,1,1.366,5.145c.147,2.076-2.606,2.5-1.96,4.734s2.739,1.326,3.561.648,1.1-1.226,1.645.258,2.006,2.945,3.439,1.98-.13-3.65.882-4.385,3.122,2.175,4.085-.292-2.14-2.712-2.726-4.233a52.515,52.515,0,0,1-1.257-5.691",
    transform: "translate(-390.637 59.774)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.486,368.686c1.49-.19,2.386-.408,2.78-.157s1.452,2.839,2.417,5.615",
    transform: "translate(-392.121 58.149)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.5,371.292c1.6-2.873,3.078-5.408,3.383-5.483a4.168,4.168,0,0,1,1.536.59",
    transform: "translate(-398.348 57.063)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.822,367.823c-.723,2.4-1.533,4.856-1.74,5.393-.415,1.076-3.476-1.076-4.773.855s.746,2.951,1.793,3.145,1.407.716-.027,1.82-1.49,3.614.716,4.054,2.9-3.2,4.11-2.9.3,4.248,2.812,3.5,1.418-3.732,2.207-5.158c.416-.75,1.97-3.677,3.588-6.623",
    transform: "translate(-403.168 57.903)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.928,363.34a28.781,28.781,0,0,1,5.625-1.916,26.408,26.408,0,0,1,5.3,4.027,11.976,11.976,0,0,1-.688,3.244",
    transform: "translate(-403.984 55.243)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.036,357.039c-.628.6-1.178,1.118-1.591,1.488A28.807,28.807,0,0,1,713,363.05c-1.086.386-2.188-1.986-3.659-1.122s-.975,2.391.293,3.035,1.084,1.176-.221,1.084-2.948,1.362-1.759,2.961,3,.276,3.773.027,1.544-.082.524.938a1.919,1.919,0,0,0,.91,3.237c1.573.449,2.593-1.335,3.338-2.464s1.517-1.214,5.131-2.621c1.152-.447,2.753-1.121,4.422-1.824",
    transform: "translate(-410.085 53.424)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.863,340.68c2.947,1.124,4.943,3.441,6.818,6.788s3.393,6.16,3.172,7.207c-.153.726-3.7,4.5-6.686,7.477",
    transform: "translate(-406.504 46.628)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.07,324.513c-4.192-1.274-16.438-.055-20.631,5.571s-1.82,13.9,6.013,17.1,18.811.5,21.348-3.806S745.144,328.485,732.07,324.513Z",
    transform: "translate(-409.19 39.722)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 -80.569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612.556,307.073a70.388,70.388,0,0,0,9.465-3.57c2.866-1.288,5.632-2.15,6.03-3.856s-3.132-4.275-3.217-6.348c-.147-3.6,9.3-6.253,8.805-12.063s-2.7-10.3-5.275-9.414S603.283,281.091,601,285.651c-1.5,3,3.5,23.426,5.276,23.442S610.436,307.686,612.556,307.073Z",
    transform: "translate(-454.33 17.979)",
    fill: "#ef7e17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.009,333.4c.566-.127,5.309-10.2,7.25-12.951,2.419-3.421,6.733-9.469,6.332-10.754s-2.616-3.482-4.265-4.555c-7.8-5.076-16.4-9.783-20.152-7.209-3.731,2.56-19.227,22.222-16.726,25.311s6.65,2.437,9.959.736,6.767-2.29,10.739,2.344C586.389,327.774,591.443,333.529,592.009,333.4Z",
    transform: "translate(-469.512 28.57)",
    fill: "#ef7e17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.705,338.66c.091-.144.183-.287.27-.425q1.58-2.465,3.32-4.81c-2.694-6.9-3.8-14.485-1.4-21.089,1.824-5,5.094-8.78,10.563-9.612a43.015,43.015,0,0,1,9.078-.166,65.783,65.783,0,0,0-4.308-5.953,6.754,6.754,0,0,0-4.069-1.414,30.066,30.066,0,0,0-9.715,2.512,59.705,59.705,0,0,1-9.057,3.468c-2.277.658-5.817,1.523-6.051,3.165s1.159,4.378,1.531,5.759c1.544,5.738-3.311,11.312-7.428,12.165-2.607.541-7.2-7.006-8.553-7.015s-4.072,5.271-6.2,8.17-7.468,12.608-7.335,13.472c.088.566,4.815,4.577,9.82,8.48,2.19-4.366,7.376-7.394,12.216-8.441a30.28,30.28,0,0,1,15.2.92A19.516,19.516,0,0,1,625.705,338.66Z",
    transform: "translate(-460.301 27.733)",
    fill: "#4b7eba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.841,354.229c-.147-1.284,6.889-4.221,3.628-7.711s-11.426-7.313-11.131-9.373c.231-1.609,4.042-18.355,2.739-20.21s-5.352-2.71-8.468-3.408c-3.7-.827-10.741-2.892-12.2-1.762s-3.9,6.87-5.387,6.4c-2.106-.658-7.042-7.94-11.46-14.573a54.483,54.483,0,0,0-10.355-.205c-4.852.6-7.579,3.771-8.637,8.467a27.734,27.734,0,0,0,.964,14.346c3.111-3.572,9.364-9.894,11.391-9.763s6.269,2.894,7.238,3.8c1.752,1.639,3.475,3.34,5.159,5.052,3.373,3.422,10.2,11.2,10.5,11.465a2.126,2.126,0,0,1,.328,2.556,13.516,13.516,0,0,1-3.99,4.316,33.161,33.161,0,0,0-4.964,4.87c-2.792,3.4-9.177,13.776-10.959,13.776-.872,0-7.773-3.37-10.1-4.918a83.859,83.859,0,0,1-9.659-6.965,12.055,12.055,0,0,1-3.405-4.1c-.26-.623-.878-5.806-.258-7.3a26.037,26.037,0,0,0-12.91-1.578c-4.078.545-9.855,3.083-11.186,7.251,1.452,1.086,2.841,2.091,4.052,2.923,11.033,7.577,22.8,10.228,22.873,12.836.034,1.188-6.444,4.681-7.009,6.5s1.069,4.613,1.822,7.254a68,68,0,0,1,2.014,7.783c.416,2.589,1.122,7.373,2.9,8.071s4.654-.072,7.445-1.21c7.962-3.243,12.322-7.691,14.852-7.469.892.078,4.065,5.8,6.659,7.061,1.9.929,4.256-2.158,6.429-1.152a26.759,26.759,0,0,0,7.608,2.623c5.969.882,24.21.589,27.74-12.614S688.989,355.513,688.841,354.229Zm1.848,17.6a12.733,12.733,0,0,1-8.981,9.131c-3.827,1.056-10.74,2.783-19.382-3.929s.268-21.362,1.506-22.449c3.628-3.19,11.547-5.2,15.939-3.27,4.133,1.819,6.488,3.223,8.453,7.233C690.1,362.375,691.836,367.517,690.69,371.826Z",
    transform: "translate(-456.41 31.061)",
    fill: "#4b7eba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.183,305.948c.031.658-3.475,8.819-3.061,9.612s7.271.464,10.6,1.233c3.094.715,8.349,2.316,8.744,2.126s.627-1.03.662-1.427c.633-6.913,10.8-15.739,8.992-19.2s-8.212,5.442-9.756,4.119,6.988-9.855,3.972-11.547-6.424,5.823-7.207,5.442.661-9.487-1.839-9.708-3.384,10.3-5,10.223-2.943-9.34-6.473-8.164,2.225,8.642,1.472,9.782-8.164-.651-8.974,1.734S649.11,304.407,649.183,305.948Z",
    transform: "translate(-437.493 24.163)",
    fill: "#dceaf8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.808,363.607c-.686-4.4-2.692-12.825-4.617-13.555s-8.865,3.227-10.141,3.9c-3.088,1.619-8.545-6.434-11.561-4.947s2.776,8.321,4.037,11.34-12.42,3.977-11.465,8.095,13.019-3.605,13.9-1.84-12.283,5.737-10.481,8.678,11.583-5.711,12.54-4.62-8.017,8.593-6.546,9.843,9.121-8.092,10.812-7.429-1.172,10.3,1.731,10.3.5-9.891,3.27-10.444c1.326-.266,8.622.863,9.531-.568S621.495,368.012,620.808,363.607Z",
    transform: "translate(-460.026 50.008)",
    fill: "#dceaf8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.842,366.788s-24.5,10.8-16.874,29.042,13.183,31.192-4.307,41.045S574.452,425.337,562.1,456.92s38.834,43.877,41.482,72.005-19.123,44.6-19.123,44.6",
    transform: "translate(-471.175 57.474)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200.572 379.162)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M634.42,340.52a5.4,5.4,0,0,1,1.665.941",
    transform: "translate(-640.906 -332.6)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.4,349.15s1.929-1.493,1.628-3.1-3.3-3.06-4.659-4.611-1.451-9.025-3.257-9.855-6.25.4-8.761,4.433c1.308-.358,3.182.5,5.278,1.394,1.209.517,2.794.808,3.608,1.5A23.449,23.449,0,0,1,658.4,349.15Z",
    transform: "translate(-637.197 -336.414)",
    fill: "#4b7eba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.96,347.477c.3-1.935-5.105-3.994-9.056-3.217-6.154,1.207-8.825,3.99-10.369,4.681,0,0-.477,3.08-2.357,2.74a2.476,2.476,0,0,1-.577-4.635s-2.083-6.015-2.986-6.661-3.052,1.064-5.568,3.1-4.406,4.079-4.429,5.674,2.4,6,8.246,7.591,10.948,6.485,13.858,5.487,5.681-5.635,7.761-8.7S666.659,349.415,666.96,347.477Z",
    transform: "translate(-642.07 -332.714)",
    fill: "#4b7eba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658,347.5s1.983-.079,1.887-1.609-1.546-1.384-2.569-2.984-1.158-3.6-1.633-6.289a8.657,8.657,0,0,0-2.569-4.935c-.47-.286-7.633,1.359-9.5,4.345",
    transform: "translate(-637.085 -336.283)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.43,341.445c.391-.553.139-2.771-.234-2.293a8.492,8.492,0,0,0-1.018,2.072C651.132,341.51,651.652,342.553,652.43,341.445Z",
    transform: "translate(-633.946 -333.197)",
    fill: "#789fcb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.084,345.851c.272-.528-.392-1.768-1.148-1.135A24.855,24.855,0,0,0,646,347.381C645.838,347.757,649.032,347.887,650.084,345.851Z",
    transform: "translate(-636.098 -330.931)",
    fill: "#789fcb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.743,346.243q-.17-.544-.408-1.105a18.323,18.323,0,0,0-2.584-4.575c-3.558-4.6-4.826-4.035-7.19-5.175a6.847,6.847,0,0,0-6.63.31c-1.21.978-3.88,5.72-3.471,8.165a30.224,30.224,0,0,0,1.763,3.594",
    transform: "translate(-638.83 -335.021)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.52,347.471a8.815,8.815,0,0,1-2.32-3.8c-.41-1.987-1.531-4.164-1.972-4.229s-2.225,1.428-3.479,2.855-2,4.539-2.252,4.621c-.384.122.235-1.551-.068-1.724s-4,1.594-1.7,6.416,5.027,6.052,10.225,6.986,9.3,3.615,11.881,3.274,6.083-6.685,9.332-10.873c1.4-1.809,3.029-2.842,3.236-3.741.263-1.141-3.237-3.741-6-2.777-.6.21.194.8-.028.991s-1.1-.527-3.987-.041-10,3.85-10,3.85-.743,3.151-2.643,2.29A2.625,2.625,0,0,1,644.52,347.471Z",
    transform: "translate(-641.92 -333.05)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.249,346.622c.48-.376-.067-1.8-.243-1.962-.2-.177-1.021.6-1.9,1.151A9.169,9.169,0,0,0,646,347.493C646.542,348.544,648.721,347.817,650.249,346.622Z",
    transform: "translate(-636.099 -330.891)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.7,341.766c-.289.74-1.53-.1-1.465-.468.028-.153.45-.8.634-1.21.289-.634.484-1.054.92-.815A2.833,2.833,0,0,1,652.7,341.766Z",
    transform: "translate(-633.922 -333.147)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.944,343.47a13.971,13.971,0,0,1-2.6-2.907c-.463-.781-1.363-2.962-2.235-3.155s-1.083.628-1.449.967-.586.293-.819.671",
    transform: "translate(-636.577 -333.905)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.339,335.983a3.153,3.153,0,0,0-2.665,1.13,6.421,6.421,0,0,0-1.735,2.4",
    transform: "translate(-637.368 -334.494)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.133,342.6a.5.5,0,0,0-.224-.943.519.519,0,0,0-.518.669A.472.472,0,0,0,646.133,342.6Z",
    transform: "translate(-636.355 -332.128)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.827,339.092a.438.438,0,0,1-.737-.224c-.11-.323.361-.655.638-.525A.468.468,0,0,1,649.827,339.092Z",
    transform: "translate(-634.82 -333.516)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.536,341.2a4.551,4.551,0,0,1-1.019,1.434c-.57.442-1.179.781-1.688,1.168a2.094,2.094,0,0,0-.658,1.117s.229-.187.7-.553c.316-.242.4-.294,1.571-1.183A2.953,2.953,0,0,0,647.536,341.2Z",
    transform: "translate(-636.856 -332.318)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.763,339.74a2.691,2.691,0,0,0,1-.573,3.362,3.362,0,0,0,.518-.614.71.71,0,0,1,1.009-.283,1.6,1.6,0,0,0-.483.369,4.7,4.7,0,0,1-1.146.987A1.577,1.577,0,0,1,648.763,339.74Z",
    transform: "translate(-634.948 -333.58)",
    fill: "#1f5ea9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M655.417,334.928c-5.149.589-15,7.267-16.328,17.784s12.863,16.543,19.49,16.344c9.708-.3,19.418-11.254,12.209-22.948S655.417,334.928,655.417,334.928Z",
    transform: "translate(-639.003 -334.925)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M623.835,341.035s-6.011-9.8-8-19.946,2.865-17.541,8.107-19.416,10.364-.551,12.767-.256c2.994.367,3.466,4.117-1,3.161-6.106-1.308-14.764-.846-16.9,7.08s3.067,22.157,6.977,27.03",
    transform: "translate(-448.241 30.016)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.458,333.037s-10.487-10.07-24.166-7.865-16.434,10.089-12.375,16.028",
    transform: "translate(-457.457 40.055)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.432,333.941s-8.984-5.519-16.983-6.843-20.55,2.935-16.757,11.177",
    transform: "translate(-456.711 40.888)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.412,360.292s12.133,13.3,14.119,13.45,13.384-9.85,13.384-9.85",
    transform: "translate(-444.491 54.775)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x2: 20.986,
    y2: 16.45,
    transform: "translate(138.499 379.78)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.739,361.879s15.05,15.544,18.25,16.536S657.43,363.95,657.43,363.95",
    transform: "translate(-446.017 55.435)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.937,334.2s-2.567,2.979-2.9,4.192,9.6,9.047,13.238,11.806,5.572,4.286,5.572,4.286",
    transform: "translate(-457.111 43.937)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.582,326.188c-.986.109-7.911,9.08-8.187,10.129s9.654,9.377,13.792,9.6,8.569-4.689,5.966-9.129S628.568,325.967,626.582,326.188Z",
    transform: "translate(-446.993 40.606)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.557,316.274c.839-.391,17.516,15.831,17.571,16.823s-3.64,5.629-5.462,6.124-17.155-15.722-17.32-17.542S627.369,316.825,628.557,316.274Z",
    transform: "translate(-444.937 36.487)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.965,303.321c.727,1.513,11.254-2.5,15.078-3.972s13.24-4.927,12.393-6.766-10.2,2.207-13.735,3.567S604.01,301.336,604.965,303.321Z",
    transform: "translate(-452.594 26.454)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.456,334.106c1.046.855,5.693-6.017,9.93-12.983,3.962-6.515,7.609-13.091,6.471-14.121-1.154-1.045-5.159,5.677-9.156,12.356C586.54,326.309,582.424,333.264,583.456,334.106Z",
    transform: "translate(-461.57 32.594)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.31,322.538c-1.89,2.106-3.659,4.185-5.042,5.98",
    transform: "translate(-448.705 39.093)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.184,334.971c-.7,1.134-1.05,1.982-.9,2.4.994,2.759,21.845,18.976,23.721,18.755s18.576-19.307,18.059-22.285-17.507-20.631-20.818-20.3c-.784.079-5.99,5.169-10.917,10.448",
    transform: "translate(-449.543 35.354)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.271,308.076s16.082.65,22.844,4.194",
    transform: "translate(-436.657 33.085)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.317,347.947s6.235,17.048,6.691,23.067",
    transform: "translate(-451.177 49.646)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.862,334.95c-1.393.63-.166,2.456.965,1.765A1.006,1.006,0,0,0,660.862,334.95Z",
    transform: "translate(-429.608 44.205)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.032,333.158c-.911.634.082,2.553,1.158,1.6A.988.988,0,0,0,659.032,333.158Z",
    transform: "translate(-430.259 43.434)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.7,331.319c-.654.238-.771,2.1.662,1.6S658.913,330.877,657.7,331.319Z",
    transform: "translate(-430.857 42.707)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.935,328.462s9.493,7.933,9.714,9.148-4.589,6.127-4.589,6.127",
    transform: "translate(-430.981 41.553)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.589,356.532c-.911.77,0,2.1,1.021,1.185S640.305,355.925,639.589,356.532Z",
    transform: "translate(-438.343 53.13)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.861,354.575c-.63.5-.082,2.041,1.076,1.214S638.8,353.831,637.861,354.575Z",
    transform: "translate(-439.015 52.3)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.333,352.775c-1.032.517-.027,2.207.91,1.434S637.491,352.2,636.333,352.775Z",
    transform: "translate(-439.721 51.591)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.305,358.68s5.262,8.894,7.1,8.747,10.223-6.252,9.047-8.311-5.812-8.679-7.65-7.8-8.5,7.36-8.5,7.36",
    transform: "translate(-442.043 51.015)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.417,334.928c-5.149.589-15,7.267-16.328,17.784s12.863,16.543,19.49,16.344c9.708-.3,19.418-11.254,12.209-22.948S655.417,334.928,655.417,334.928Z",
    transform: "translate(-438.431 44.237)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.21,331.728s-9.635-2.63-15.96,1.489-11.547,11.473-14.637,18.46a42.419,42.419,0,0,0-3.475,12.99",
    transform: "translate(-441.281 42.566)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.565,311.993c-2-2.031-3.979-3.963-5.688-5.459-6.178-5.405-14.563-8.826-16-9.047s-22.618,22.066-22.176,24.052,5.3,6.509,9.378,5.074,6.62-3.088,8.5-2.317c1.063.439,5.752,5.1,12.036,10.828",
    transform: "translate(-470.127 28.686)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.529,300.161a118.785,118.785,0,0,1,3.817,12.542c.11,1.325-9.517,10.481-10.37,10.041-1.023-.529-5.489-5.425-10.185-10.27",
    transform: "translate(-456.796 29.797)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.59,300.53c-1.974-2.345-3.459-4.1-3.888-4.645-1.325-1.691-1.428-3.918.811-6.409s4.256-4.051,4.477-7.913-2.281-9.1-3.495-8.992-25.661,11.878-26.653,13.091.551,9.487,3.42,16.549c.8,1.966,1.706,4.408,2.6,6.943",
    transform: "translate(-453.992 18.336)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.6,303.931c-2.548-3.229-5.554-6.858-8.136-9.942",
    transform: "translate(-444.886 27.233)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.638,381.721c1.1,1.029,8.817,10.458,15.929,12.57,4.708,1.4,18.607,1.029,24.345-5.516s6.767-15.888.736-25.229-8.9-10.15-8.311-12.576,3.162-12.577,3.677-18.094,2.28-23.756,2.352-25.081,6.33-7.4,4.931-9.535-5.715,3.965-6.672,3.451.272-2.521,2.109-6.124-1.029-5.516-3.015-2.647-2.887,4.78-3.99,4.633,1.875-9.653-.994-10.095-3.254,4.947-3.916,8.184-1.021-.194-2.522-2.9-2.5-5.17-4.427-4.066,1.544,8.293,2.205,10.2-7.391-2.061-8.788,1.323,3.751,3.9,4.781,5.223-3.09,9.267-4.119,12.136-3.237,8.238-4.56,8.751-6.62-8.311-11.475-15.077c-.245-.344-.508-.7-.786-1.076",
    transform: "translate(-441.701 24.518)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.983,333.42c13.292,9.712,26.335,14.232,26.555,15.334s-8.714,5.517-12.246,8.054-8.274,5.959-8.935,5.738-6.785-7.227-9.047-5.517,3.972,8.55,3.585,9.323-10.2,4.855-10.095,6.9,3.7,1.434,5.626.882,5.959-2.151,6.289-1.379-10.921,5.626-9.984,7.667,4.192.442,6.178-.442,5.3-3.2,5.9-2.481-4.082,5.405-4.964,7.226,1.323,3.145,3.364.718,5.02-5.628,5.626-5.352-.661,5.683.773,7.227,3.419,0,3.64-2.648-.11-4.634,1.71-5.35,8.9-.736,21.991-5.444c9.633-3.463,11.762-5.98,14.01-7.79",
    transform: "translate(-459.7 43.612)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.161,325.278c3.516,3.155,7.431,6.526,11.438,9.632",
    transform: "translate(-460.796 40.23)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(800.047 60.222) rotate(19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M640.08,444.239c-1.519-2.611-2.541-5.594-4.357-8.018-.9-1.2-1.931-2.368-3.11-2.61s-7.618,4.563-8.5,4.927c-3.2,1.323-11.364.783-11.585,3.977s10.481,1.263,10.536,2.587-11.363,1.268-11.418,4.909,10.647-.433,11.528,1-9.156,7.333-6.894,9.816,8.6-4.853,9.543-4.137-4.248,10.039-1.268,11.143,5.856-10.426,6.9-10.591,4.354,8.882,7.278,7.006-.055-7.337,1.655-8.661c.44-.34,5.161-1.754,5.608-2.814S641.544,446.755,640.08,444.239Z",
    transform: "translate(-449.792 85.227)",
    fill: "#dceaf8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.417,451.3s-9.836-11.027-11.758-18.416",
    transform: "translate(-442.728 84.931)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.611,458.417c3.311-1.544,15.336.442,24.878-6.289.1-.072,2.222-1.638.544-2.44a13.868,13.868,0,0,1-5.158-3.922,42.658,42.658,0,0,1-6.253-11.9c-.282-1.447-2.853-1.127-3.407-1.372-3.874-1.711-12.1-3.7-13.31-4.579s2.1-8.69.941-10.579-4.757-1.58-6.3-2.665-7.6-12.131-10.584-14.338-10.757-7.778-20.134-4.027-11.915,13.81-13.516,15.336c-1.016.968-6.068-1.807-7.722,1.965s1.064,11.163-1.4,13.039c-1.616,1.231-29.214,18.856-29.164,20.135a18.371,18.371,0,0,0,2.209,5.681c1.407,2.107,2.732,4.454,4.045,6.62,1.582,2.609,5.039,7.742,6.979,8.063s18.076-7.84,18.873-7.214c.906.708-1.173,8.729-3.028,16.253a2.15,2.15,0,0,1,1.127,1.2c1.342,3.386,3.71,6.96,6.913,8.839,3.076,1.806,7.427,2.369,10.482.181a34.978,34.978,0,0,0,9.913-11.344c-3.1.011-13.511.041-14.646-1.875s-.535-4.668-.681-6.788a32.992,32.992,0,0,1-.047-3.844c-.251-3.369-.44-15.858,2.173-18.645,1.772-1.891,4.239-2.109,6.69-2.256,3.381-.205,14.772-.668,18.349-.719,1.826-.027,3.977.314,4.873,2.171,1.4,2.906,2.41,13.879,2.454,17.174.028,2.044,1.019,8.383,1.04,9.511a4.238,4.238,0,0,1-3.077,4.43c-.232.068-.464.127-.7.181,1.176,1.757,2.449,3.455,3.544,5.265a22.422,22.422,0,0,0,6.434,6.992c2.454,1.669,5.913,3.322,8.624,1.309a19.248,19.248,0,0,0,1.642-1.4c-.04-.869-.084-1.621-.136-2.226C722.308,475.33,716.3,459.961,719.611,458.417Zm-22.506-31.608c-5.185,4.358-20.52,5.793-24.6-3.751s3.064-20.9,5.847-22.341c4.579-2.372,12.08-3.09,17.211,2.593S702.291,422.451,697.105,426.809Z",
    transform: "translate(-442.572 69.209)",
    fill: "#4b7eba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.066,411.973c-1.6-.331-3.033,7.393-4.357,6.841s1.931-9.434-.662-9.984-2.262,8.88-3.2,8.77-1.323-10.591-3.64-10.481.276,9.765-1.047,10.371-2.759-8.494-5.186-7.612,2.262,9.6,1.27,10.591-7.061.166-7.172,2.262,5.35,2.427,5.241,3.364c-.045.385-1.328.9-1.629,1.415-.149.253,1.18,5.029,3.744,9.085,2.661,4.209,6.6,7.69,8.716,7.129,4.154-1.1,8.668-15.041,9.414-21.657C728.438,414.235,727.666,412.3,726.066,411.973Z",
    transform: "translate(-412.233 74.226)",
    fill: "#dceaf8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.1,498.773c-.624-1-1.509-9.731-2.442-10.913s-3.063-.756-5.22-.817c-6.609-.184-18.955-1.27-19.423.064s-.657,6.219-.747,8.966c-.365,10.976-.476,17.044,8.24,17.6s29.733,2.041,30.009-3.364S707.09,501.967,705.1,498.773Z",
    transform: "translate(-422.588 107.181)",
    fill: "#ef7e17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.324,487.678l-.021,0c-4.263-.814-8.514-1.674-12.679-2.906-3.083-.91-6.9-2.412-8.406-1.237s-2.359,4.508-3.086,5.383c-2.978,3.585-11.142.5-15.39,2.1s-6.935,9.487-3.771,11.087,33.557,10.757,35.819,8.937c1.592-1.281,8.365-17.864,8.587-19.532S674.142,487.879,673.324,487.678Z",
    transform: "translate(-442.757 105.789)",
    fill: "#ef7e17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.6,468.35a9.24,9.24,0,0,1-1.27.712c-3.175,1.444-7.269.32-10.117-1.435a25.946,25.946,0,0,1-7.99-7.47c-1.881-2.876-4.018-5.721-5.748-8.716-.323.011-.645.023-.967.037-1.979.089-3.957.129-5.936.146a38.293,38.293,0,0,1-4.2,6.58c-2.877,3.628-6.659,8.457-11.306,9.8-8.284,2.4-15.22-2.777-19.082-9.6-.214.95-.408,1.851-.57,2.679-1.071,5.439-4.851,28.291-3.888,29.46s6.052,2.358,9.255,3.313c3.8,1.132,7.673,1.939,11.561,2.691a2.3,2.3,0,0,1,.531.068,2.875,2.875,0,0,0,2.88-.548c1.243-.829,1.856-2.742,2.2-4.038,1.82-6.785,5.405-17.874,7.226-18.315s12.192.221,12.411,2.483c.144,1.476-.234,18.75.371,19.644s12.689,1.476,19.525,1.547c1.834.018,4.18-.35,4.986-1.016S716.754,476.267,716.6,468.35Z",
    transform: "translate(-435.787 92.637)",
    fill: "#4b7eba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.154,409.017s3.369-19.014,18.225-22.839,33.542,7.387,43.836,20.846c14.932,19.525,32.65,63.442,26.472,96.539s-47.7,15.283-29.089-18.093,77.522-60.706,118.09-44.541",
    transform: "translate(-418.845 65.213)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.3,422.469s1.792,11.4,10.961,14.612",
    transform: "translate(-411.309 80.603)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.034 467.09)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M663.031,416.917c.069,4.226-.253,5.538,6.986,7.084s8.925-3.751,10.182-4.492,3.481-5.34,3.393-6.777c-.041-.671-.883-.961-3.553,1.1s-5.974,4.123-10.219,3.581-5.081-4.089-5.959-5.318C663.862,412.1,662.962,412.69,663.031,416.917Zm3.251.29a.1.1,0,0,1,.021.065,7.627,7.627,0,0,0,3.149.955c1.643.061,4.143-.293,4.637.392s-1.175,1.932-2.219,2.225a6.607,6.607,0,0,1-3.83.059,8.725,8.725,0,0,1-1.928-.91,1.548,1.548,0,0,0,.6-.706,4.482,4.482,0,0,0,.133-.668s-.559-.122-.572-.391c-.01-.225.018-.781.033-.957a.259.259,0,0,0-.037-.014Z",
    transform: "translate(-655.485 -390.795)",
    fill: "#fce5d1",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.292,418.282s-2.708.6-2.518-1.182c.062-.576.544-8.641-.962-9.55-.4-.239-3.394,2.556-4.614,2.607-1.363.055-.01-2.648-1.277-3.022-1.907-.56-3.452,1.449-7.282.879-3.962-.59-6.059-2.951-5.775-4.1a7.442,7.442,0,0,1,3.6-4.256c1.568-.909,4.091-1.383,8.487-.374a17.294,17.294,0,0,1,5.463,1.918c2.71,1.439,3.857-.592,5.993,1.424s-1.11,15.654-1.11,15.654",
    transform: "translate(-655.564 -396.352)",
    fill: "#ef7e17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.057,408.305c.222.275.819-.589,1.543-.733s1.8-.129,2.067-.59-1.531-1.287-2.7-.569S664.835,408.029,665.057,408.305Z",
    transform: "translate(-654.693 -393.274)",
    fill: "#ef7e17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.684,407.592c-.882.1-1.618.763-.294,1.189,1.42.454,2.62,2.551,3,2.573.464.027.314-.829.017-1.689C673.98,408.43,673.452,407.4,671.684,407.592Z",
    transform: "translate(-652.312 -392.677)",
    fill: "#ef7e17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.344,415.537s-1.471,4.412-2.461,5.437c-.406.419-1.718.355-1.775-.062a27.7,27.7,0,0,1,3.338-5.526A5.486,5.486,0,0,1,678.344,415.537Z",
    transform: "translate(-650.883 -389.429)",
    fill: "#ef7e17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.868,413.807a2.568,2.568,0,0,0-2.613.6",
    transform: "translate(-649.575 -390.14)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.142,414.991a.8.8,0,0,0-.341-1.148",
    transform: "translate(-649.349 -390.07)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.458,423.642c-.341-1.339-.45-1.632,2.982-6.92,0,0,4.535.8,4.763-1.687s-3.046-2.729-3.046-2.729",
    transform: "translate(-650.804 -390.709)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.317,421.417a1.8,1.8,0,0,0,2.259-.8,28.044,28.044,0,0,0,1.161-5.156",
    transform: "translate(-650.796 -389.4)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.7,404.516a21.678,21.678,0,0,0-1.454,3.756c-.6,2.085-2.109,9.742-2.1,10.45s.127,4.376,1.216,5.643,2.047,1.853,5.129,2.117c3.125.266,7.282-.589,7.979-1.512l2.279-3.012",
    transform: "translate(-655.437 -393.945)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.623,417.748l-1.5.018a29.6,29.6,0,0,0,.193-6.122c-.323-2.225-.687-3.388-1.168-3.684s-1.447.035-2.361.4a15.094,15.094,0,0,1-2.5.846c-.58.1-.4-.661-.427-.936s-.1-.788-2.359-.491a11.366,11.366,0,0,1-5.926-.637c-2.32-.774-4.158-2.6-4.023-3.165s1.666-.188,1.914-.515-.637-.94-.512-1.584,2.95-2.344,5.1-2.57a12.6,12.6,0,0,1,6.5.882,20.22,20.22,0,0,1,5.268,2.713c.348.236.812-.7,1.4-.474s.451,1.183.51,1.367.375.065.933-.277c.467-.286,1.461-.487,1.4,1.875a36.765,36.765,0,0,1-.569,5.475A44.8,44.8,0,0,1,683.623,417.748Z",
    transform: "translate(-655.269 -396.15)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.659,412.032c-.559-.044-1.042-.069-1.335-.074-1.22-.018-4.442-.318-4.543-.311-.125.009-.266.558-.157.6s4.944.2,5.724.344",
    transform: "translate(-651.1 -390.983)",
    fill: "#4b7eba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.786,407.88a13.447,13.447,0,0,1,.623,1.6,13.588,13.588,0,0,1-1.921,4.582c-1.336,2.294-2.074,3.124-1.775,3.428a7.92,7.92,0,0,0,4.126,1.237",
    transform: "translate(-654.397 -392.547)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.245,410.109c-.307-.32-1.39.63-2.037,1.5s-1.179,1.9-.78,2.16,1.354-1.226,1.885-1.9S672.5,410.369,672.245,410.109Z",
    transform: "translate(-652.884 -391.648)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.883,408.866c-.241-.228-.957.626-1.548,1.58-.476.77-.825,1.837-.514,2.023s1.015-1.176,1.346-1.795C666.535,409.986,667.136,409.105,666.883,408.866Z",
    transform: "translate(-654.79 -392.153)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.037,409.98c.021.068.416.089.453.159s-.488,2.764-.1,3.537,3.115,1.514,3.643,1.282,1.547-3.479,1.573-3.568.158-.17.5-.14.6.245.593.358-1.072,3.613-.607,4.265,4.988,1.809,5.47,1.488,2.236-4.136,2.243-4.2.733.1.866,0,.262-.528.117-.61a45.02,45.02,0,0,0-4.665-1.27,29.831,29.831,0,0,0-3-.377c-.216-.028-.381-.2-.794-.289-.49-.1-.636.037-.865-.051a11.832,11.832,0,0,0-3.227-1.009c-1.98-.337-2.075-.193-2.125-.139A1.492,1.492,0,0,0,663.037,409.98Zm7.155,1.672c.355-.29,2.677.04,3.667.317a7.808,7.808,0,0,1,2.119.805c.209.2-1.529,3.853-2,4.086s-4.242-.764-4.517-1.339A8.047,8.047,0,0,1,670.191,411.651Zm-6.1-1.455c.218-.2,1.214-.069,2.093.133a5.659,5.659,0,0,1,1.851.7c.112.178-.783,3.227-1.261,3.434a5.288,5.288,0,0,1-3.02-1.006A7.531,7.531,0,0,1,664.094,410.2Z",
    transform: "translate(-655.484 -391.942)",
    fill: "#4b7eba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.085,406.771c-.091-.623-1.425-.63-2.141-.25a1.652,1.652,0,0,0-.753,1.747c.141.377.613-.317,1.265-.589S668.174,407.394,668.085,406.771Z",
    transform: "translate(-654.606 -393.219)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.55,407.675c-.256.521,1.524,1.166,2.364,1.7s1.564,1.991,1.979,1.626-.027-2.034-1.138-2.734S670.808,407.157,670.55,407.675Z",
    transform: "translate(-652.371 -392.729)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.453,418.828a2.827,2.827,0,0,1,3.42-.786",
    transform: "translate(-653.647 -388.458)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.95,416.707a1.892,1.892,0,0,1-.76,1.452",
    transform: "translate(-654.587 -388.881)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.369,415.715a2.993,2.993,0,0,0,.023,1.03c.119.285,1.093.747,2.706.825a12.084,12.084,0,0,0,3.713-.368.759.759,0,0,0,.364-.409",
    transform: "translate(-654.528 -389.293)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.156,415.46a4.266,4.266,0,0,0,2.365,1.18c2.565.539,5.02-.187,5.749.514s-1.815,2.746-4.48,2.592a5.755,5.755,0,0,1-3.933-1.581",
    transform: "translate(-654.725 -389.399)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M661.044,426.909c3.9,3.417,15.466,6.224,24.142.133s3.6-20.645-1-25.415c-6.744-6.989-21.385-6.811-25.2,6.388S661.044,426.909,661.044,426.909Z",
    transform: "translate(-657.699 -397.047)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M686.8,443.651s-3.21,11.034-9.39,19.327-14.912,9.671-19.825,7.051-7.374-7.3-8.773-9.281c-1.741-2.461.718-5.335,3.012-1.387,3.136,5.4,9.3,11.5,16.6,7.752s14.342-17.166,15.32-23.336",
    transform: "translate(-434.602 89.401)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.3,443.514s-.406,14.533,10.423,23.178,18.516,5.384,20.185-1.614",
    transform: "translate(-422.522 89.345)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.817,443.359s1.952,10.361,6.349,17.173,15.988,13.241,19.539,4.893",
    transform: "translate(-421.892 89.28)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.085,427.573s1.7-18.329.471-19.9-16.291-3.287-16.291-3.287",
    transform: "translate(-419.214 73.092)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.929,
    y1: 29.298,
    transform: "translate(281.666 525.349)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.878,430.514s1.388-21.59-.027-24.628-23.106-3.926-23.106-3.926",
    transform: "translate(-419.845 72.083)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.169,467.772s3.932-.1,5.054-.672.245-13.187-.161-17.736-.545-11.5-.545-11.5",
    transform: "translate(-414.685 86.997)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.677,449.343c.745.657,12.039-.246,13-.747s.454-13.45-2.164-16.662-9.231-3.193-10.77,1.72S670.178,448.021,671.677,449.343Z",
    transform: "translate(-425.317 83.611)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.205,455.48c-.853-.359-.054-23.61.644-24.319s6.614-1.088,8.206-.072-.109,23.269-1.345,24.615S663.411,455.988,662.205,455.48Z",
    transform: "translate(-428.945 83.925)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.172,486.852c.226-1.662-10.766-4.124-14.765-5.009s-13.759-3.2-14.069-1.2,9.727,3.793,13.422,4.607S669.872,489.037,670.172,486.852Z",
    transform: "translate(-437.463 104.439)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.839,485.1c.18-1.338-8.107-1.7-16.26-1.657-7.626.037-15.139.376-15.421,1.884-.286,1.53,7.538,1.421,15.323,1.328C700.58,486.555,708.662,486.418,708.839,485.1Z",
    transform: "translate(-422.584 105.928)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.079,459.512c1.128-.232,1.867-.525,2.059-.887,1.374-2.589-.636-28.928-2.059-30.169s-26.782-.774-28.64,1.612-3.5,26.83-1.035,29.058c.594.536,7.7,1.042,15.037,1.129",
    transform: "translate(-430.06 82.813)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.707,450.82c2.936-.011,5.778-.1,8.113-.289",
    transform: "translate(-424.43 92.259)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.468,411.26c1.4.607,1.928-1.527.657-1.9A1.006,1.006,0,0,0,653.468,411.26Z",
    transform: "translate(-432.688 75.136)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.336,413.773c1.081.249,1.834-1.778.408-1.933A.989.989,0,0,0,653.336,413.773Z",
    transform: "translate(-432.786 76.184)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.874,415.944c.616.324,2.071-.838.74-1.567S651.731,415.341,652.874,415.944Z",
    transform: "translate(-432.926 77.167)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.067,421.937s-.51-12.361.241-13.34,7.622-.722,7.622-.722",
    transform: "translate(-433.489 74.527)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.712,412.353c1.183.156,1.551-1.41.191-1.553S682.781,412.23,683.712,412.353Z",
    transform: "translate(-420.176 75.752)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.427,414.956c.8.13,1.567-1.311.177-1.612S682.247,414.763,683.427,414.956Z",
    transform: "translate(-420.341 76.798)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.127,417.319c1.077.416,1.652-1.464.45-1.638S681.92,416.849,683.127,417.319Z",
    transform: "translate(-420.396 77.776)",
    fill: "#1f5ea9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.176,422.951s3.067-10.269,1.721-11.53-11.5-3.367-12.235-1.111-2.519,10.136-.63,10.9,11.163,1.342,11.163,1.342",
    transform: "translate(-420.905 75.138)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.044,426.909c3.9,3.417,15.466,6.224,24.142.133s3.6-20.645-1-25.415c-6.744-6.989-21.385-6.811-25.2,6.388S661.044,426.909,661.044,426.909Z",
    transform: "translate(-430.664 70.043)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.741,416.306s4.529,8.9,11.83,10.814,16.257.835,23.507-1.574a47.013,47.013,0,0,0,12.209-6.139",
    transform: "translate(-432.309 78.043)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.515,423a82.365,82.365,0,0,1,18.237,5.359c2.842,1.223,8.078.732,9.167-3.3.368-1.36-5.332-.661-5.921-2.389s2.757-2.245,4.45-2.354,1.74-1.086,1.115-3.659-1.851-5.425.061-6.233,3.088,3.6,3.53,5.221,1.544,1.073,1.4-.437-1.362-6.328.624-7.322,2.4,2.249,2.832,5.029c.413,2.655.508,3.735.846,3.724s.477-2.1,1.213-5.076,3.288-2.921,3.115.219c-.183,3.311-.733,5.37-.065,5.606s1.253-2.106,1.989-3.506,3.4-2.014,2.8,1.2-1.288,12.512-2.171,15.123-5.405,15.336-19.858,18.866c-10.928,2.669-16.7,1.472-17.388,3.141s4.684,13.034,6.427,29.4c.018.166.035.333.052.5",
    transform: "translate(-418.279 74.47)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.239,478.73c.129-.592.242-1.112.335-1.55,1.747-8.144,4.722-18,3.451-18.631s-16.3,6.611-19.115,7.778-12.928,4.805-13.217,6.458,2.793,5.81-.652,7.05-5.918-7.393-6.887-5.616-3.958,9.18-6.073,8.492-.961-3.078.035-6.011,3.294-5.5.453-3.82-7.09,5.022-8.692,2.6,7.439-6.6,6.807-7.521-2.654-.3-6.112.161-3.972-2.951-.068-4.011,6.214-1.5,5.952-2.556-7.68-.153-7.039-2.621,9.343-1.924,10.373-2.759,26.752-18.41,31.184-21.736,13.674-8.246,15.867-9.441.862-3.864,3.724-14.61,10.47-16.26,19.172-16.414,18.319,9.892,20.449,14.317c3.219,6.683,1.472,18.737,1.451,20.247",
    transform: "translate(-449.326 68.766)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.991,489.583c2.065-9.23,5.456-24.176,7.414-32.962",
    transform: "translate(-436.358 94.789)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.156,486.78c-1.168,2.992-2.115,5.536-2.64,7.153-2.759,8.494-4.858,16.495-6.424,16.576s-33.426-8.267-34.323-9.091,1.3-6.2,4.308-8.634,5.517-1.989,8.866-2,4.928-1.591,5.292-3.707c.075-.44.49-2.345,1.117-5.163",
    transform: "translate(-442.351 105.294)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.1,491.706c.161-10.4.483-23.4.16-24.611-.133-.5-3.766-.217-7.462-.433-3.21-.188-6.521-.947-6.943-.5-.854.916-6.868,14.978-10.962,25.31",
    transform: "translate(-429.338 98.695)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.024,485.356c.094,6.484.173,11.213.435,11.937.688,1.908,3.619,2.674,7.427,4.733s3.72,8.692,2.546,10.354-34.493.086-35.294-1.124-1.325-8.842-1.475-17.051c-.038-2.034-.016-5.117.034-8.627",
    transform: "translate(-421.964 106.726)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.525,462.663c.715,9.121.909,20.832,1.039,29.9",
    transform: "translate(-414.536 97.299)",
    fill: "none",
    stroke: "#1f5ea9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Bg);
export default __webpack_public_path__ + "static/media/404-bg.2b7d6634666eaed365264fc038dd8e7b.svg";
export { ForwardRef as ReactComponent };